import { uniq } from 'lodash-es';

import { useYAxisConfig } from './useYAxisConfig.js';
import type { TimeseriesUnit } from '../../core/types/timeseries.js';
import type { TimeseriesPerVariant } from '../types/timeseries.js';

function getAllUnits(data: TimeseriesPerVariant) {
  return uniq(
    data.shapePriority.flatMap((v) => data[v]?.map((s) => s.unit)),
  ) as TimeseriesUnit[];
}

export function useDataByYAxis(
  data: TimeseriesPerVariant,
): TimeseriesPerVariant {
  const yAxis = useYAxisConfig();
  const allUnits = getAllUnits(data);
  const hasAnyAxisDefined = yAxis.left || yAxis.right;
  const hasOnlyOneAxisDefined = !yAxis.left || !yAxis.right;
  const shouldFilterData =
    allUnits.length > 1 && hasOnlyOneAxisDefined && hasAnyAxisDefined;

  if (shouldFilterData) {
    const [firstUnit] = allUnits;

    return {
      line: data.line.filter((series) => series.unit === firstUnit),
      bar: data.bar.filter((series) => series.unit === firstUnit),
      area: data.area.filter((series) => series.unit === firstUnit),
      band: data.band.filter((series) => series.unit === firstUnit),
      shapePriority: data.shapePriority,
    };
  }

  return data;
}
